import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';

export default function MasterArea() {
  const [areas, setAreas] = useState([]);
  const [name, setName] = useState('');
  const [editId, setEditId] = useState(null);

  useEffect(() => { load(); }, []);
  async function load() {
    const { data } = await supabase.from('areas').select('*').order('name');
    setAreas(data || []);
  }
  async function handleSave() {
    if (!name.trim()) return;
    if (editId) { await supabase.from('areas').update({ name }).eq('id', editId); }
    else { await supabase.from('areas').insert({ name }); }
    setName(''); setEditId(null); load();
  }
  async function handleDelete(id) {
    if (!window.confirm('Hapus area ini?')) return;
    await supabase.from('areas').delete().eq('id', id); load();
  }

  return (
    <div style={{ padding: 'clamp(16px,4vw,28px) clamp(12px,4vw,24px) 60px', maxWidth: 560 }}>
      <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.5rem', marginBottom: 4 }}>Area</div>
      <div style={{ fontSize: '.82rem', color: 'var(--muted)', marginBottom: 24 }}>Area pengiriman yang tersedia untuk PO</div>

      <div style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '18px 20px', marginBottom: 18, boxShadow: 'var(--shadow)' }}>
        <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1rem', marginBottom: 14 }}>{editId ? 'Edit Area' : 'Tambah Area Baru'}</div>
        <div style={{ display: 'flex', gap: 10 }}>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Nama area, e.g. Sumenep Kota"
            onKeyDown={e => e.key === 'Enter' && handleSave()}
            onFocus={e => e.target.style.borderColor = 'var(--gold)'}
            onBlur={e => e.target.style.borderColor = '#DDD'}
            style={{ flex: 1, border: '1.5px solid #DDD', borderRadius: 8, padding: '8px 12px', fontSize: '.88rem', outline: 'none' }} />
          <button onClick={handleSave} style={{ padding: '8px 16px', borderRadius: 8, background: '#CD5226', color: '#fff', border: 'none', fontSize: '.82rem', fontFamily: "'DM Sans',sans-serif" }}>
            {editId ? 'Simpan' : 'Tambah'}
          </button>
          {editId && <button onClick={() => { setEditId(null); setName(''); }} style={{ padding: '8px 12px', borderRadius: 8, background: 'var(--cream)', border: '1px solid var(--border)', fontSize: '.82rem', fontFamily: "'DM Sans',sans-serif", color: 'var(--muted)' }}>Batal</button>}
        </div>
      </div>

      <div style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
        {areas.length === 0 ? (
          <div style={{ padding: '28px', textAlign: 'center', color: 'var(--muted)', fontSize: '.84rem' }}>Belum ada area</div>
        ) : areas.map((a, i) => (
          <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', borderBottom: i < areas.length - 1 ? '1px solid var(--border)' : 'none' }}>
            <span style={{ fontSize: '.88rem' }}>{a.name}</span>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setEditId(a.id); setName(a.name); }} style={{ padding: '4px 10px', borderRadius: 6, background: 'var(--cream)', border: '1px solid var(--border)', fontSize: '.74rem' }}>Edit</button>
              <button onClick={() => handleDelete(a.id)} style={{ padding: '4px 10px', borderRadius: 6, background: '#FFEBEE', border: '1px solid #FFCDD2', color: '#C62828', fontSize: '.74rem' }}>Hapus</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
